import { tWarning } from "../../../i18n/engine";
import { t } from "../../../i18n";
import { analyzeWall, fmt, type WallInput, type WallResult } from "@tasduvar/engine";
import { Section } from "./common";
import type { WallAdvisory } from "../advisories";

/** Diğer itki yöntemiyle statik devrilme/kayma GK'ları (tek satırlık kıyas; hata verirse satır düşer). */
function otherMethod(wall: WallInput, result: WallResult): { label: string; overturning: number; sliding: number } | null {
  const other = result.geometry.pressureMethod === "back-face" ? "virtual-plane" : "back-face";
  try {
    const r = analyzeWall({ ...wall, checks: { ...wall.checks, pressureMethod: other } });
    const c = r.cases.static;
    if (!c) return null;
    return { label: other === "back-face" ? t("kademe bazlı") : t("sanal düzlem"), overturning: c.overturning.classic.factor, sliding: c.sliding.classic.factor };
  } catch { return null; }
}

export function Warnings({ wall, result, advisories = [] }: { wall: WallInput; result: WallResult; advisories?: WallAdvisory[] }): JSX.Element {
  const icon = { info: "ⓘ", warn: "!", error: "✗" } as const;
  const backface = result.geometry.pressureMethod === "back-face";
  const st = result.cases.static;
  const alt = otherMethod(wall, result);
  return (
    <Section id="warnings" title={t("13. Uyarılar ve Kabuller")}>
      {advisories.length ? (
        <div data-advisories>
          <h3>{t("Kabuller ve dikkat edilecekler")}</h3>
          <ul>{advisories.map((a) => <li key={a.id} className={a.severity === "warn" ? "advisory-warn" : ""}>{a.severity === "warn" ? "⚠ " : ""}{a.text}</li>)}</ul>
        </div>
      ) : null}
      <ul>
        <li>{backface
          ? t("Yöntem: kademe bazlı — itki gerçek arka yüze her kademe için kendi ψᵢ ile (Coulomb / M-O) uygulanmış; kademe çıkıntısı üstündeki dolgu düşey yük alınmıştır (Das / ders kitabı ağırlık duvarı pratiği).")
          : t("Yöntem: sanal düzlem — itki topuktan geçen sanal arka düzlem üzerinde hesaplanmış, düzlem ile duvar arasındaki dolgu ağırlık alınmıştır (iCad Rijit ile aynı yaklaşım).")}
          {alt && st ? ` ${t("Kıyas — statik devrilme / kayma GK:")} ${fmt(st.overturning.classic.factor)} / ${fmt(st.sliding.classic.factor)}; ${alt.label}: ${fmt(alt.overturning)} / ${fmt(alt.sliding)}.` : null}
        </li>
        <li>{t("Deprem hesabı statik-eşdeğer Mononobe-Okabe yöntemiyle (TBDY 2018 §16.12.2); dinamik artımın etkime noktası girdi tablosundaki gibidir.")}</li>
        {result.warnings.map((w) => <li key={w.code + (w.context ?? "")} className={w.severity === "error" ? "bad" : ""}>{icon[w.severity]} {tWarning(w.code, w.message)}{w.context ? ` (${w.context})` : ""}</li>)}
      </ul>
    </Section>
  );
}
